<template>
  <b-col>
    <b-row class="mb-5">
      <b-col>
        <div class="tsny_header text-center">
          {{ section.subsection ? section.subsection : section.section }}
        </div>
      </b-col>
    </b-row>
    <b-row class="my-3" v-if="creatingExam">
      <b-col>
        <b-button class="tsny_button mr-3" @click="addQuestion(section)">
          + Add Question
        </b-button>
        <b-button
          v-if="section.hasShortAnswer"
          class="tsny_button mr-3"
          @click="addShortAnswer(section)"
        >
          + Add Short Answer
        </b-button>
      </b-col>
    </b-row>
    <b-row class="question-row" v-if="creatingExam">
      <draggable
        class="question-col"
        tag="b-col"
        v-model="section.questions"
        :move="onMove"
        ><exam-question
          v-for="(question, index) in section.questions"
          :key="question.key"
          :creating-exam="creatingExam"
          :value="question"
          :num-choices="section.numChoices"
          :choices="section.choices"
          :has-short-answer="section.hasShortAnswer"
          :index="index"
          :category-options="categoryOptions"
          @delete-question="deleteQuestion(section, index)"
      /></draggable>
    </b-row>
    <b-row class="question-row justify-content-between" v-if="!creatingExam">
      <b-col
        class="question-col col-auto"
        v-for="(column, columnIndex) in columns"
        :key="`col-${columnIndex}`"
      >
        <exam-question
          v-for="(question, index) in column"
          :key="question.key"
          :creating-exam="creatingExam"
          :value="question"
          :num-choices="section.numChoices"
          :choices="section.choices"
          :has-short-answer="section.hasShortAnswer"
          :index="calculateIndex(columnIndex, index)"
        />
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
import { _ } from "vue-underscore";
import ExamQuestion from "../Exams/ExamQuestion";
import Draggable from "vuedraggable";

export default {
  name: "ExamSection",
  components: { Draggable, ExamQuestion },
  props: {
    section: {
      type: Object,
      default: null
    },
    creatingExam: {
      type: Boolean,
      default: false
    },
    categoryOptions: {
      type: Array,
      default: null
    },
    windowWidth: {
      type: Number,
      default: null
    }
  },
  computed: {
    numCols() {
      return this.creatingExam
        ? 1
        : this.windowWidth < 1280
        ? 1
        : this.windowWidth < 1600
        ? 2
        : this.windowWidth < 1920
        ? 3
        : this.windowWidth < 2240
        ? 4
        : 5;
    },
    columns() {
      return this.createColumns(this.section.questions, this.numCols);
    },
    columnQuestionStartIndexes() {
      let questionCounts = [0, ...this.columns.map(column => column.length)],
        indexes = {};
      questionCounts.forEach((count, index) => {
        indexes[index] = _.chain(questionCounts)
          .first(index + 1)
          .reduce((k, v) => k + v)
          .value();
      });
      return indexes;
    }
  },
  methods: {
    /*
      Prevent drag-and-drop of short-answer questions when scoring an exam
       */
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element,
        draggedElement = draggedContext.element;
      return (
        this.creatingExam ||
        !(
          relatedElement.isShortAnswer === true ||
          draggedElement.isShortAnswer === true
        )
      );
    },
    addQuestion(section) {
      section.questions.push({
        // We generate a random ID number instead of using the index of the question
        // This is to prevent collisions for the labels on our multiple choice bubbles when adding/removing questions and to allow Vue to properly re-render the question component on delete
        key: Math.random()
      });
    },
    addShortAnswer(section) {
      section.questions.push({
        key: Math.random(),
        isShortAnswer: true,
        shortAnswer: [null, null, null, null],
        shortAnswerOptions: [[null, null, null, null]]
      });
    },
    deleteQuestion(section, index) {
      section.questions.splice(index, 1);
    },
    createColumns(items, colLength) {
      const columns = [];
      for (let i = 0; i < colLength; i++) {
        const start = Math.ceil(i * (items.length / colLength));
        const end = Math.ceil(((i + 1) * items.length) / colLength);
        const colItems = items.slice(start, end);
        columns.push(colItems);
      }
      return columns;
    },
    calculateIndex(columnIndex, questionIndex) {
      return this.columnQuestionStartIndexes[columnIndex] + questionIndex;
    }
  }
};
</script>

<style scoped>
.question-row {
  padding-top: 10px;
}
.question-col > .row:nth-child(odd) {
  background: #f8f8f8;
}
</style>
